import { mapActions, mapState } from 'vuex'
export const Mixin = {
  computed: {
    ...mapState({
      isAir: state => state.module1.isAir,
      user: state => state.module1.user,
      isChina: state => state.module1.isChina,
      ProjectList: state => state.module1.ProjectList,
      projectName: state => state.module1.projectName,
      addDevState: state => state.module1.addDevState,
      proAreaList: state => state.module1.proAreaList,
      areaInfoFirst: state => state.module1.areaInfoFirst,
      areaInfo: state => state.module1.areaInfo,
      deviceList: state => state.module1.deviceList,
      deviceLog: state => state.module1.deviceLog,
      File: state => state.module1.File,
      projectDev: state => state.module1.projectDev,
      proDevNum: state => state.module1.proDevNum,
      proDevNum1: state => state.module1.proDevNum1,
      whitchArea: state => state.module1.whitchArea,
      deviceLogList: state => state.module1.deviceLogList,
      ipDeviceList: state => state.module1.ipDeviceList,
      areaLog: state => state.module1.areaLog,
      AreaID: state => state.module1.AreaID,
      AreaName: state => state.module1.AreaName,
      projectID: state => state.module1.projectID,
      devPage: state => state.module1.devPage,
      brandList: state => state.module1.brandList,
      Cityaqi: state => state.module1.Cityaqi,
      U: state => state.module1.U,
      XF: state => state.module1.XF,
      smartstatus: state => state.module1.smartstatus,
      showDb: state => state.module1.showDb
    })
  },
  methods: {
    ...mapActions(['getDeviceParam', 'login', 'getsmartmodel', 'getDeviceType', 'startsmartmodel', 'searchAreaXF', 'controlxf', 'checklog', 'getCityaqi', 'getProjectList', 'getDevicebrandList', 'getIpDeviceList', 'getAreaLog', 'editDevice', 'getDeviceLogList', 'addDevice', 'delDevice', 'refreshToken', 'getProAreaList', 'getAreaInfoFirst', 'getAreaInfo', 'getDeviceList', 'getDeviceLog', 'addArea', 'editArea', 'delArea', 'getProjectDev'])
  }
}
